module.exports = __webpack_public_path__ + "img/levelup_circle.b441d113.svg";